import React, { useState } from 'react';
import ENTRIES from './entries.json';
import { randomOther } from '../lib/random';

export { randomOther };

function GuideViewer() {
  const [index, setIndex] = useState(() => randomOther(-1, ENTRIES.length));
  const entry = ENTRIES[index];

  return (
    <div className="fm-guide">
      <article className="fm-guide-entry">
        <p className="fm-guide-tag">{entry.tag}</p>
        <p className="fm-guide-head" title={entry.title}>
          <span className="fm-guide-clamp">
            <strong className="fm-guide-title">{entry.title}</strong> <span className="fm-guide-dash" aria-hidden="true">—</span> <span className="fm-guide-fact">{entry.fact}</span>
          </span>
        </p>
        <div className="fm-guide-body" tabIndex={0} aria-label={entry.title}>
          {entry.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
        <p className="fm-guide-source">
          <span>source: <a href={entry.source.url} target="_blank" rel="noopener noreferrer">{entry.source.label} ↗</a></span>
          <button type="button" className="ms-btn ms-btn-small" onClick={() => setIndex((i) => randomOther(i, ENTRIES.length))}>🔀 Shuffle</button>
        </p>
      </article>
    </div>
  );
}

export default GuideViewer;
